import React, { useCallback, useState } from 'react';

import { App, Button } from 'antd';

import SelectCreditCard from 'v2/components/Shared/SelectCreditCard';
import type { ICard } from 'v2/components/Shared/SelectCreditCard';
import { useCardsListSubscriptions } from 'v2/hooks/useCardsList';
import { ShoppingPaymentStatusId } from 'v2/interfaces/shopping';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingService from 'v2/services/shopping/subscription';

interface ChangePaymentMethodProps {
  delivery: ShoppingDelivery;
  closeQuickView: (refetch?: boolean) => void;
}

export const ChangePaymentMethod = ({ delivery, closeQuickView }: ChangePaymentMethodProps) => {
  const { message } = App.useApp();
  const [open, setOpen] = useState(false);

  const cardsListSubscriptionsQuery = useCardsListSubscriptions({ enabled: open });

  const openPaymentMethod = () => setOpen(true);

  const closePaymentMethod = () => setOpen(false);

  const onSelectCard = useCallback(
    (card: ICard) => {
      setOpen(false);
      shoppingService.changeSubscriptionPayment(delivery.subscription_id, card).subscribe(
        () => {
          message.success('Forma de pagamento alterada com sucesso!');
          const shouldRefetchList = true;
          closeQuickView(shouldRefetchList);
        },
        error => message.error(error instanceof Error ? error.message : 'Falha ao alterar forma de pagamento')
      );
    },
    [delivery, closeQuickView, message]
  );

  if (!!delivery?.product.allows_card && delivery?.payment_status.id !== ShoppingPaymentStatusId.CANCELADA) {
    return (
      <>
        <Button color='default' variant='filled' onClick={openPaymentMethod} block>
          Trocar forma de pagamento
        </Button>
        <SelectCreditCard
          isOpen={open}
          onClose={closePaymentMethod}
          onFinish={onSelectCard}
          cardsList={cardsListSubscriptionsQuery.data}
          isLoadingCards={cardsListSubscriptionsQuery.isLoading}
        />
      </>
    );
  }

  return null;
};
